import { CapturePhoto } from '@georapbox/capture-photo-element/dist/capture-photo.js';
import '@georapbox/files-dropzone-element/dist/files-dropzone-defined.js';
import '@georapbox/resize-observer-element/dist/resize-observer-defined.js';
import { isWebShareSupported } from '@georapbox/web-share-element/dist/is-web-share-supported.js';
import '@georapbox/web-share-element/dist/web-share-defined.js';
import * as $ from 'jquery/dist/jquery.js';
import './custom-clipboard-copy.js';
import { CheckSession, Login, SetEvent, TransactionCheck } from './services/api.js';
import { getHistory, getSettings, setHistory, setSettings } from './services/storage.js';
import { toastAlert } from './toast-alert.js';

$.fn.serializeObject = function(){
	var o = {};
	var a = this.serializeArray();
	$.each(a, function() {
		if (o[this.name] !== undefined) {
			if (!o[this.name].push) {
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(this.value || '');
			console.log(this.value);
		} else {
			o[this.name] = this.value || '';
		}
	});
	return o;
};

// login.then(out=>{
//   console.log(out)
// })

// console.log(login);
// Login({username: 'agoes', password: 'sa'})
//   .then(function(success){
//     console.log(success);
//   })
//   .catch(function(err){
//     console.log(err);
//   })

(async function () {
  CheckSession().then(success=>{
    showLogin(false);
    console.log(success)
  }).catch(err=>{
    showLogin(true);
    console.log(err)
  })

  function showLogin(_state){
    if (_state){
      $('div.signinContainer').show();
      $('div.mainContainer').hide();
    } else {
      $('div.signinContainer').hide();
      $('div.mainContainer').show();
    }
  }

  $('form.signinForm').submit(function(e){
    e.preventDefault();
    Login($(this).serializeObject()).then(success=>{
      console.log(success.data.userAccess);
      if (success.data && success.data.userAccess && success.data.userAccess.length > 0) {
        showLogin(false);
        // SetEvent(success.data.userAccess[0]).then((eventSet) => {
        //   console.log(eventSet);
        //   showLogin(false);
        // }).catch((err) => {
        //   console.log('test', err);
        // })
      } else {
        return toastAlert('User Not Assigned to any event!', 'danger');
      }
    }).catch(err=>{
      console.log(err);
      if (err.responseJSON && err.responseJSON.status){
        return toastAlert(err.responseJSON.status.error.message, 'danger');
      } else {
        return toastAlert('Login Failed', 'danger');
      }
    })
  })

  
  const NO_BARCODE_DETECTED = 'No barcode detected';
  const ACCEPTED_MIME_TYPES = ['image/jpg', 'image/jpeg', 'image/png', 'image/apng', 'image/gif', 'image/webp', 'image/avif'];
  const capturePhotoEl = document.querySelector('capture-photo');
  const cameraResultsEl = document.getElementById('cameraResults');
  const fileResultsEl = document.getElementById('fileResults');
  const scanInstructionsEl = document.getElementById('scanInstructions');
  const scanBtn = document.getElementById('scanBtn');
  const scanMethodSelect = document.getElementById('scanMethod');
  const dropzoneEl = document.getElementById('dropzone');
  const cameraViewEl = document.getElementById('cameraView');
  const fileViewEl = document.getElementById('fileView');
  const resizeObserverEl = document.querySelector('resize-observer');
  const scanFrameEl = document.getElementById('scanFrame');
  const globalActionsEl = document.getElementById('globalActions');
  const delegationBtn = document.getElementById('handover_photo_img');
  const delegationDialog = document.getElementById('handoverIdentityDialog');
  const delegationDialogCloseBtn = document.getElementById('handoverIdentityCloseBtn');
  const memberBtn = document.getElementById('runner_photo_img');
  const memberDialog = document.getElementById('memberIdentityDialog');
  const memberDialogCloseBtn = document.getElementById('memberIdentityCloseBtn');
  const historyBtn = document.getElementById('historyBtn');
  const historyDialog = document.getElementById('historyDialog');
  const historyList = document.getElementById('historyList');
  const deleteHistoryBtn = document.getElementById('deleteHistoryBtn');
  const settingsBtn = document.getElementById('settingsBtn');
  const settingsDialog = document.getElementById('settingsDialog');
  const settingsForm = document.forms['settings-form'];
  const supportedFormatsEl = document.getElementById('supportedFormats');
  const loadingBackdrop = document.getElementById('loadingBackdrop');
  let shouldRepeatScan = true;
  let rafId;

  // Loading Backdrop Animation Functions
  const showLoader = () => {
    loadingBackdrop.hidden = false;

    // Animate backdrop
    gsap.to(loadingBackdrop, {
      opacity: 1,
      duration: 0.3,
      ease: "power2.out"
    });

    // Animate container with bounce
    const container = loadingBackdrop.querySelector('.loading-container');
    gsap.fromTo(container,
      {
        scale: 0.5,
        opacity: 0,
        y: -50
      },
      {
        scale: 1,
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "back.out(1.7)",
        delay: 0.1
      }
    );

    // Animate spinner rings with stagger
    const rings = loadingBackdrop.querySelectorAll('.spinner-ring');
    gsap.fromTo(rings,
      {
        scale: 0,
        opacity: 0
      },
      {
        scale: 1,
        opacity: 1,
        duration: 0.4,
        stagger: 0.1,
        ease: "back.out(1.5)",
        delay: 0.3
      }
    );
  };

  const hideLoader = () => {
    const container = loadingBackdrop.querySelector('.loading-container');

    // Animate container out
    gsap.to(container, {
      scale: 0.8,
      opacity: 0,
      y: 30,
      duration: 0.3,
      ease: "power2.in"
    });

    // Animate backdrop out
    gsap.to(loadingBackdrop, {
      opacity: 0,
      duration: 0.3,
      delay: 0.1,
      ease: "power2.in",
      onComplete: () => {
        loadingBackdrop.hidden = true;
        // Reset transforms
        gsap.set(container, { scale: 1, y: 0 });
      }
    });
  };

  function doCheck(transactionID){
    $('#delegationContainer').hide();
    $('#takenContainer').hide();

    // Show loading backdrop
    showLoader();

    return TransactionCheck(transactionID.split('%')[0]).then(tx=>{
      // Hide loading backdrop on success
      hideLoader();
      // console.log(tx);
      const toastContainer = document.getElementById('toastContainer');
      toastContainer.childNodes.forEach(el => el.remove());
      createResult(transactionID, cameraResultsEl);
      if (tx.delegation){
        $('#delegationContainer').show();        
      }
      if (tx.handover){
        $('#takenContainer').show();        
      }
      $(cameraResultsEl).prop('class', '');
      $(cameraResultsEl).prop('class', 'results');
      $('#handoverStatus').prop('class', '');
      $('#instructionStatus').prop('class', '');
      $('#instructionStatusText').text('');
      for (var key in tx) {
        $('#'+key).text(tx[key]);
        if (key == 'medical_screening') {
          $('#medicalStatusText').text(tx[key]);
        }
        if (key == 'handover') {
          if (tx.handover == true) {
            $('#handoverStatusText').text('INVALID ENTRY');
            $('#handoverStatus').addClass('already-handover');
            $(cameraResultsEl).addClass('redBorder');
          } else {
            if (tx.info_note == 'RED') {
              $('#handoverStatus').prop('class', '');
              $('#handoverStatus').addClass('already-handover');
              $('#handoverStatusText').text('INVALID ENTRY');
            } else {
              $('#handoverStatusText').text('VALID ENTRY');
            }
            if (tx.registration_type == 'FAST_TRACK') {
              $('#handoverStatus').addClass('vip');
              $(cameraResultsEl).addClass('vip');
            } else if (tx.info_note == 'YELLOW') {
              $('#handoverStatus').addClass('warning');
            } else if (tx.info_note == 'BLUE') {
              $('#handoverStatus').addClass('blueBg');
            } else {
              if (tx.info_note != 'RED') $('#handoverStatus').addClass('success');
            }
          }
        }
        if (key == 'registration_type'){
          if (tx[key] == 'FAST_TRACK'){
            $('#'+key).parent().addClass('vip');
          } else {
            $('#'+key).parent().removeClass('vip');
          }
        }
        if (key == 'rpc_file_id') {
          const handoverImg = $('img#handover_photo_img')[0];
          const handoverModalImg = $('img#handover_photo_modal_img')[0];
          const handoverContainer = $('#handover_photo');

          // Check if elements exist before using GSAP
          if (handoverImg && handoverModalImg) {
            // Set opacity to 0 first
            gsap.set([handoverImg, handoverModalImg], { opacity: 0, scale: 0.8 });

          // Set the image sources
            $('img#handover_photo_img').prop('src', `https://utilities.borobudurmarathon.com/extractFace/${tx.rpc_file_id}`);
            $('img#handover_photo_modal_img').prop('src', `https://utilities.borobudurmarathon.com/extractFace/${tx.rpc_file_id}`);

            // Animate in when image loads
            handoverImg.onload = () => {
              gsap.to(handoverImg, {
                opacity: 1,
                scale: 1,
                duration: 0.6,
                ease: "back.out(1.7)"
              });
              // Re-enable click functionality
              $(handoverImg).css('pointer-events', 'auto');
            };

            handoverModalImg.onload = () => {
              gsap.to(handoverModalImg, {
                opacity: 1,
                scale: 1,
                duration: 0.5,
                ease: "power2.out"
              });
            };

            // Handle image load error
            handoverImg.onerror = () => {
              // Hide image and show "-" text
              $(handoverImg).hide();
              handoverContainer.html('<span class="image-error-placeholder">No Image Found.</span>');
              // Disable click functionality
              handoverContainer.css({
                'cursor': 'default',
                'pointer-events': 'none'
              });
            };

            handoverModalImg.onerror = () => {
              $(handoverModalImg).hide();
            };
          } else {
            // Fallback if elements don't exist
            console.warn('Handover image elements not found in DOM');
            handoverContainer.html('<span class="image-error-placeholder">No Image Found.</span>');
          }
        }
        if (key == 'member_id') {
          const runnerImg = $('#runner_photo_img')[0];
          const modalImg = $('img#member_photo_modal_img')[0];
          const runnerContainer = $('#runner_photo');

          // Check if elements exist before using GSAP
          if (runnerImg && modalImg) {
            // Set opacity to 0 first
            gsap.set([runnerImg, modalImg], { opacity: 0, scale: 0.8 });

          // Set the image sources
            $('#runner_photo_img').prop('src', `https://utilities.borobudurmarathon.com/memberImage/${tx.member_id}`);
            $('img#member_photo_modal_img').prop('src', `https://utilities.borobudurmarathon.com/memberImage/${tx.member_id}`);

            // Animate in when image loads
            runnerImg.onload = () => {
              gsap.to(runnerImg, {
                opacity: 1,
                scale: 1,
                duration: 0.6,
                ease: "back.out(1.7)"
              });
              // Re-enable click functionality
              $(runnerImg).css('pointer-events', 'auto');
            };

            modalImg.onload = () => {
              gsap.to(modalImg, {
                opacity: 1,
                scale: 1,
                duration: 0.5,
                ease: "power2.out"
              });
            };

            // Handle image load error
            runnerImg.onerror = () => {
              // Hide image and show "-" text
              $(runnerImg).hide();
              runnerContainer.html('<span class="image-error-placeholder">No Image Found.</span>');
              // Disable click functionality
              runnerContainer.css({
                'cursor': 'default',
                'pointer-events': 'none'
              });
            };

            modalImg.onerror = () => {
              $(modalImg).hide();
            };
          } else {
            // Fallback if elements don't exist
            console.warn('Runner image elements not found in DOM');
            runnerContainer.html('<span class="image-error-placeholder">No Image Found.</span>');
          }
        }
        if (key == 'info_note') {
          if (tx[key] == 'YELLOW'){
            $(cameraResultsEl).addClass('warning');
          } else if (tx[key] == 'RED'){
            $(cameraResultsEl).addClass('redBorder');
          } else if (tx[key] == 'GREEN') {
            $(cameraResultsEl).addClass('success');
          } else if (tx[key] == 'BLUE') {
            $(cameraResultsEl).addClass('blueBorder');
          }
        }
        if (key == 'instruction') {
          $('#instructionStatusText').text(tx[key]);
        }
        // console.log(key)
      }
    }).catch((err) => {
      console.log(err);
      // Hide loading backdrop on error
      hideLoader();
      return toastAlert('Transaction Not Found', 'danger');
    })
  };

  $('#testButton').click(function(e){
    console.log('kelik');
    // doCheck('REALOKASI4CC');
    doCheck('IR1LAIN83257');
  })

  if (!('BarcodeDetector' in window)) {
    try {
      window.BarcodeDetector = (await import('barcode-detector')).default;
    } catch (err) {
      cameraViewEl.hidden = true;
      fileViewEl.hidden = true;
      scanMethodSelect.hidden = true;
      globalActionsEl.hidden = true;
      return toastAlert('BarcodeDetector API is not supported by your browser.', 'danger');
    }
  }

  if (!isWebShareSupported()) {
    document.querySelectorAll('web-share').forEach(el => {
      el.hidden = true;
      el.disabled = true;
    });
  }

  const { value: history = [] } = await getHistory();

  renderHistoryList(history);

  capturePhotoEl.addEventListener('capture-photo:video-play', evt => {
    scanFrameEl.hidden = false;
    resizeScanFrame(evt.detail.video);
    scan();

    const trackSettings = capturePhotoEl.getTrackSettings();
    const trackCapabilities = capturePhotoEl.getTrackCapabilities();
    const zoomLevelEl = document.getElementById('zoomLevel');

    if (trackSettings?.zoom && trackCapabilities?.zoom) {
      const zoomControls = document.getElementById('zoomControls');
      const minZoom = trackCapabilities?.zoom?.min || 0;
      const maxZoom = trackCapabilities?.zoom?.max || 10;
      let currentZoom = trackSettings?.zoom || 1;

      zoomControls.hidden = false;
      zoomLevelEl.textContent = currentZoom;

      zoomControls.addEventListener('click', evt => {
        const zoomInBtn = evt.target.closest('[data-action="zoom-in"]');
        const zoomOutBtn = evt.target.closest('[data-action="zoom-out"]');

        if (zoomInBtn && currentZoom < maxZoom) {
          currentZoom += 0.5;
        }

        if (zoomOutBtn && currentZoom > minZoom) {
          currentZoom -= 0.5;
        }

        zoomLevelEl.textContent = currentZoom;

        capturePhotoEl.zoom = currentZoom;
      });
    }
  }, {
    once: true
  });

  capturePhotoEl.addEventListener('capture-photo:error', evt => {
    cameraViewEl.hidden = true;
    fileViewEl.hidden = false;
    scanMethodSelect.hidden = true;

    const error = evt.detail.error;

    if (error.name === 'NotFoundError') {
      return;
    }

    const errorMessage = error.name === 'NotAllowedError' ? 'Permission to use webcam was denied. Reload the page to give appropriate permissions to webcam.' : error.message;

    toastAlert(errorMessage, 'danger');
  }, {
    once: true
  });

  CapturePhoto.defineCustomElement();

  dropzoneEl.accept = ACCEPTED_MIME_TYPES.join(',');

  const capturePhotoVideoEl = capturePhotoEl.shadowRoot.querySelector('video');
  const formats = await window.BarcodeDetector.getSupportedFormats();
  const barcodeDetector = new window.BarcodeDetector({ formats });
  const { value: settings = {} } = await getSettings();

  Object.entries(settings).forEach(([key, value]) => {
    const settingInput = settingsForm.querySelector(`[name="${key}"]`);
    if (settingInput) {
      settingInput.checked = value;
    }
  });

  // if (Array.isArray(formats) && formats.length > 0) {
  //   supportedFormatsEl.textContent = `Supported formats: ${formats.join(', ')}`;
  // }

  const beep = (() => {
    const audioCtx = new (window.AudioContext || window.webkitAudioContext || window.audioContext);

    if (!audioCtx) {
      return;
    }

    return async (duration, frequency, volume, type, callback) => {
      const { value: settings } = await getSettings();

      if (!settings?.beep) {
        return;
      }

      const oscillator = audioCtx.createOscillator();
      const gainNode = audioCtx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioCtx.destination);

      if (volume) {
        gainNode.gain.value = volume;
      }

      if (frequency) {
        oscillator.frequency.value = frequency;
      }

      if (type) {
        oscillator.type = type;
      }

      if (typeof callback === 'function') {
        oscillator.onended = callback;
      }

      oscillator.start(audioCtx.currentTime);
      oscillator.stop(audioCtx.currentTime + ((duration || 500) / 1000));
    };
  })();

  function renderHistoryList(data) {
    historyList.innerHTML = '';

    if (!Array.isArray(data) || !data.length) {
      historyList.innerHTML = '<li class=>There are no saved items in history.</li>';
      deleteHistoryBtn.style.display = 'none';
    } else {
      deleteHistoryBtn.style.display = 'block';

      data.forEach(item => {
        const li = document.createElement('li');
        li.setAttribute('data-value', item);

        let historyItem;

        try {
          new URL(item);
          historyItem = document.createElement('a');
          historyItem.href = item;
          historyItem.setAttribute('target', '_blank');
          historyItem.setAttribute('rel', 'noreferrer noopener');
        } catch (err) {
          historyItem = document.createElement('span');
        }

        historyItem.textContent = item;
        historyItem.setAttribute('title', item);

        const actionsEl = document.createElement('div');
        actionsEl.className = 'history-modal__actions';

        const copyBtn = document.createElement('custom-clipboard-copy');
        copyBtn.title = 'Copy to clipboard';
        copyBtn.setAttribute('only-icon', '');
        copyBtn.setAttribute('value', item);
        actionsEl.appendChild(copyBtn);

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'history-modal__delete-action';
        removeBtn.title = 'Remove from history';
        removeBtn.setAttribute('data-action', 'delete');
        removeBtn.innerHTML = /* html */`
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3-fill" viewBox="0 0 16 16">
            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"/>
          </svg>
        `;
        actionsEl.appendChild(removeBtn);

        li.appendChild(historyItem);
        li.appendChild(actionsEl);
        historyList.appendChild(li);
      });
    }
  }

  async function addToHistory(item) {
    const { value: settings } = await getSettings();

    if (!item || !settings?.addToHistory) {
      return;
    }

    const { value: history = [], error: getHistoryError } = await getHistory();

    if (!getHistoryError && !history.find(h => h === item)) {
      const data = [...history, item];

      const { error: setHistoryError } = await setHistory(data);

      if (!setHistoryError) {
        renderHistoryList(data);
      }
    }
  }

  async function removeFromHistory(value) {
    if (!value) {
      return;
    }

    const { value: history = [], error: getHistoryError } = await getHistory();

    if (!getHistoryError) {
      const data = history.filter(item => item !== value);

      const { error: setHistoryError } = await setHistory(data);

      if (!setHistoryError) {
        renderHistoryList(data);
      }
    }
  }

  async function emptyHistory() {
    const { error: setHistoryError } = await setHistory([]);

    if (!setHistoryError) {
      renderHistoryList([]);
    }
  }

  async function vibrate(duration = 100) {
    const { value: settings } = await getSettings();

    if (typeof window.navigator.vibrate !== 'function' || !settings?.vibrate) {
      return;
    }

    try {
      window.navigator.vibrate(duration);
    } catch {
      // Fail silently...
    }
  }

  function resizeScanFrame(videoEl) {
    if (!videoEl) {
      return;
    }

    const rect = videoEl.getBoundingClientRect();

    scanFrameEl.style.cssText = `width: ${rect.width}px; height: ${rect.height}px`;
  }

  function emptyResults(resultDialog) {
    resultDialog?.querySelector('.results__item')?.remove();
  }

  async function createResult(value, resultDialog) {
    if (!value || !resultDialog) {
      return;
    }

    emptyResults(resultDialog);

    let resultItem;

    try {
      const { value: settings } = await getSettings();

      new URL(value);
      resultItem = document.createElement('a');
      resultItem.href = value;

      if (!settings?.openWebPageSameTab) {
        resultItem.setAttribute('target', '_blank');
        resultItem.setAttribute('rel', 'noreferrer noopener');
      }

      if (settings?.openWebPage) {
        resultItem.click();
      }
    } catch (err) {
      resultItem = document.createElement('span');
    }

    resultItem.className = 'results__item';
    resultItem.classList.toggle('results__item--no-barcode', value === NO_BARCODE_DETECTED);
    resultItem.textContent = value;

    resultDialog.insertBefore(resultItem, resultDialog.querySelector('.results__actions'));

    const clipboarCopyEl = resultDialog.querySelector('clipboard-copy');
    const webShareEl = resultDialog.querySelector('web-share');
    const isValidValue = value !== NO_BARCODE_DETECTED;

    if (clipboarCopyEl) {
      clipboarCopyEl.disabled = !isValidValue;
      clipboarCopyEl.hidden = !isValidValue;
    }

    if (webShareEl && isWebShareSupported()) {
      webShareEl.disabled = !isValidValue;
      webShareEl.hidden = !isValidValue;

      if (isValidValue) {
        webShareEl.setAttribute('share-text', value);
      } else {
        webShareEl.removeAttribute('share-text');
      }
    }

    resultDialog.show();
  }

  function detectBarcode(source) {
    return new Promise((resolve, reject) => {
      barcodeDetector.detect(source).then(results => {
        if (Array.isArray(results) && results.length > 0) {
          resolve(results[0]);
        } else {
          reject({
            message: 'Could not detect barcode from provided source.'
          });
        }
      }).catch(err => {
        reject(err);
      });
    });
  }

  async function scan() {
    process.env.NODE_ENV === 'development' && console.log('Scanning...');

    scanInstructionsEl.hidden = false;

    try {
      let barcode = {};
      barcode = await detectBarcode(capturePhotoVideoEl);
      window.cancelAnimationFrame(rafId);
      emptyResults(cameraResultsEl);
      // createResult(barcode.rawValue, cameraResultsEl);
      doCheck(barcode.rawValue);
      addToHistory(barcode.rawValue);
      scanInstructionsEl.hidden = true;
      scanBtn.hidden = false;
      scanFrameEl.hidden = true;
      beep(200, 860, 0.03, 'square');
      vibrate();
      return;
    } catch (err) {
      // Fail silently...
    }

    if (shouldRepeatScan) {
      rafId = window.requestAnimationFrame(() => scan());
    }
  }

  function handleFileSelect(file) {
    if (!file) {
      return;
    }

    const image = new Image();
    const reader = new FileReader();

    reader.onload = evt => {
      const data = evt.target.result;

      image.onload = async () => {
        try {
          const barcode = await detectBarcode(image);
          emptyResults(fileResultsEl);
          emptyResults(cameraResultsEl);
          // createResult(barcode.rawValue, fileResultsEl);
          doCheck(barcode.rawValue);
          addToHistory(barcode.rawValue);
          beep(200, 860, 0.03, 'square');
          vibrate();
        } catch (err) {
          emptyResults(fileResultsEl);
          createResult(NO_BARCODE_DETECTED, fileResultsEl);
        }
      };

      image.src = data;

      dropzoneEl.replaceChildren();

      const preview = document.createElement('div');
      preview.className = 'dropzone-preview';

      const imageWrapper = document.createElement('div');
      imageWrapper.className = 'dropzone-preview__image-wrapper';

      const fileNameWrapper = document.createElement('div');
      fileNameWrapper.className = 'dropzone-preview__file-name';
      fileNameWrapper.textContent = file.name;

      imageWrapper.appendChild(image);
      preview.appendChild(imageWrapper);
      preview.appendChild(fileNameWrapper);
      dropzoneEl.prepend(preview);
    };

    reader.readAsDataURL(file);
  }

  scanBtn.addEventListener('click', () => {
    scanBtn.hidden = true;
    scanFrameEl.hidden = false;
    emptyResults(cameraResultsEl);
    cameraResultsEl.close();
    scan();
  });

  scanMethodSelect.addEventListener('change', evt => {
    const value = evt.target.value;

    [cameraViewEl, fileViewEl].forEach(el => {
      el.hidden = el.id !== value;
    });

    if (value === 'cameraView') {
      shouldRepeatScan = true;

      if (
        !cameraViewEl.hidden // Assumes that element is hidden because of error.
        && !capturePhotoEl.loading
        && !cameraResultsEl.querySelector('.results__item')
      ) {
        scan();
      }
    }

    if (value === 'fileView') {
      shouldRepeatScan = false;
    }
  });

  dropzoneEl.addEventListener('files-dropzone-drop', evt => {
    handleFileSelect(evt.detail.acceptedFiles[0]);
  });

  resizeObserverEl.addEventListener('resize-observer:resize', () => {
    resizeScanFrame(capturePhotoEl.shadowRoot.querySelector('video'));
  });

  // GSAP Animation Helper Functions
  const openModalWithAnimation = (modal) => {
    modal.showModal();
    gsap.fromTo(modal,
      {
        opacity: 0,
        scale: 0.7,
        y: -50
      },
      {
        opacity: 1,
        scale: 1,
        y: 0,
        duration: 0.4,
        ease: "back.out(1.7)"
      }
    );

    // Animate the image inside
    const img = modal.querySelector('img');
    if (img) {
      gsap.fromTo(img,
        {
          opacity: 0,
          scale: 0.8
        },
        {
          opacity: 1,
          scale: 1,
          duration: 0.5,
          delay: 0.2,
          ease: "power2.out"
        }
      );
    }
  };

  const closeModalWithAnimation = (modal) => {
    gsap.to(modal, {
      opacity: 0,
      scale: 0.7,
      y: 50,
      duration: 0.3,
      ease: "power2.in",
      onComplete: () => {
        modal.close();
        // Reset transform for next open
        gsap.set(modal, { y: 0 });
      }
    });
  };

  memberBtn.addEventListener('click', () => {
    openModalWithAnimation(memberDialog);
  });

  delegationBtn.addEventListener('click', () => {
    openModalWithAnimation(delegationDialog);
  });

  settingsBtn.addEventListener('click', () => {
    settingsDialog.showModal();
  });

  historyBtn.addEventListener('click', () => {
    historyDialog.showModal();
  });

  memberDialogCloseBtn.addEventListener('click', evt => {
    closeModalWithAnimation(memberDialog);
  });

  delegationDialogCloseBtn.addEventListener('click', evt => {
    closeModalWithAnimation(delegationDialog);
  });

  historyDialog.addEventListener('click', evt => {
    if (evt.target === evt.currentTarget) {
      historyDialog.close();
    }
  });

  settingsDialog.addEventListener('click', evt => {
    if (evt.target === evt.currentTarget) {
      settingsDialog.close();
    }
  });

  settingsForm.addEventListener('change', evt => {
    const settings = {};
    const checkboxes = evt.currentTarget.querySelectorAll('input[type="checkbox"]');

    checkboxes.forEach(item => settings[item.name] = item.checked);
    setSettings(settings);
  });

  historyList.addEventListener('click', evt => {
    const target = evt.target;

    if (target.closest('[data-action="delete"]')) {
      if (window.confirm('Delete item from history?')) {
        removeFromHistory(target.closest('li').dataset.value);
      }
    }
  });

  deleteHistoryBtn.addEventListener('click', () => {
    if (window.confirm('Are you sure you want to empty history?')) {
      emptyHistory();
    }
  });
}());
